import axios from "../api/axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "../api/endpoint";

export const getDriverIds = async () => {
  const { data } = await axios.get(endpoints.driver.ids);
  return data.data.map((item) => ({
    value: item,
    label: item,
  }));
};

export const getDriverDetails = async (driverId, partnerId) => {
  if (driverId && partnerId) {
    const { data } = await axios.get(
      endpoints.driver.details(driverId, partnerId),
    );
    return data.data;
  }
  return {};
};

export const useCreateDriverLead = () => {
  return useMutation({
    mutationFn: (payload) =>
      axios.post(endpoints.createDriverLead, payload).then((res) => res.data),
    onError: (err) => {
      console.error("createDriverLead failed:", err?.response?.data || err);
    },
  });
};

const updateDriverLead = async ({ leadId, payload }) => {
  const { data } = await axios.patch(
    `${endpoints.updateDriverLead}/${leadId}`,
    payload,
  );
  return data;
};

export const useUpdateDriverLead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateDriverLead,
    onSuccess: (_response, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["driver-lead-update", variables.leadId],
      });
    },
  });
};

export const useGetDriverLeadDetails = (leadId) => {
  return useQuery({
    queryKey: ["driver-lead-details", leadId],
    queryFn: async () => {
      const res = await axios.get(`${endpoints.getDriverLeadById}/${leadId}`);

      return res.data;
    },
    enabled: Boolean(leadId),
  });
};

export const useGetDriverLead = (params, options = {}) => {
  return useQuery({
    queryKey: ["driver-lead", params?.leadId],
    queryFn: async () => {
      const res = await axios.get(endpoints.getDriverLeads, {
        params: {
          leadId: params.leadId,
        },
      });

      return res.data;
    },
    enabled: Boolean(params?.leadId) && options.enabled !== false,
  });
};

// export const useUpdateDriverLead = (leadId) => {
//   return useMutation({
//     mutationFn: (payload) =>
//       axios
//         .patch(`${endpoints.updateDriverLead}/${leadId}`, payload)
//         .then((res) => res.data),
//   });
// };

export const useDeleteDriverLead = () => {
  return useMutation({
    mutationFn: ({ leadId }) =>
      axios
        .delete(`${endpoints.deleteDriverLead}/${leadId}`)
        .then((res) => res.data),
  });
};
